import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TaskDossier\GetAllTaskDossierController::__invoke
* @see app/Http/Controllers/TaskDossier/GetAllTaskDossierController.php
* @route '/api/task-dossier'
*/
const GetAllTaskDossierController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAllTaskDossierController.url(options),
    method: 'get',
})

GetAllTaskDossierController.definition = {
    methods: ["get","head"],
    url: '/api/task-dossier',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\TaskDossier\GetAllTaskDossierController::__invoke
* @see app/Http/Controllers/TaskDossier/GetAllTaskDossierController.php
* @route '/api/task-dossier'
*/
GetAllTaskDossierController.url = (options?: RouteQueryOptions) => {
    return GetAllTaskDossierController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\TaskDossier\GetAllTaskDossierController::__invoke
* @see app/Http/Controllers/TaskDossier/GetAllTaskDossierController.php
* @route '/api/task-dossier'
*/
GetAllTaskDossierController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAllTaskDossierController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\TaskDossier\GetAllTaskDossierController::__invoke
* @see app/Http/Controllers/TaskDossier/GetAllTaskDossierController.php
* @route '/api/task-dossier'
*/
GetAllTaskDossierController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetAllTaskDossierController.url(options),
    method: 'head',
})

export default GetAllTaskDossierController